export default {
	terms: "Podmienky a OPV",
	and: "A",
	actions: {
		Submit: "Odoslať",
		BackToLogin: "Späť na prihlásenie",
		Register: "Zaregistrovať sa",
		Logout: "Odhlásiť sa",
		Update: "Aktualizovať",
		Verify: "Overiť",
		connect: "Pripojiť",
		Taptochange: "Ťuknutím zmeniť"
	},
	rules: {
		isRequired: "Povinné",
		require: "{0} je povinné",
		valid: "{0} nie je platný {0}",
		cannotContainBlankStrings: "{0} nemôže obsahovať prázdne reťazce"
	},
	options: {
		gender: ["Muž", "Žena"]
	}
};
